export const INSTANT_PAYOUT = {
  min: 0,
  max: 999,
}
